import Header from '../components/Header';
import Footer from '../components/Footer';
import Widgets from '../components/WidgetTiles';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { motion } from 'framer-motion';


const NeurologicalTesting = () => (
    <>
        <Header />
        <div id="content" role="main" className="home">
            {/* Interior Header */}
            <div id="interior-header-container" className="container-fluid">
                <div className="container">
                    <h1>TMS Therapy</h1>
                </div>
            </div>

            {/* Content Sections */}
            <div className="container py-5">
                {/* ADHD Testing */}
                <div className="row align-items-center mb-5">
                    <div className="col-md-6">
                        <h2>What is TMS Therapy?</h2>
                        <p className="text-secondary" style={{ fontSize: 18 }}>
                            Transcranial Magnetic Stimulation (TMS) is a noninvasive, well-tolerated procedure that uses pulsed magnetic fields to stimulate nerve cells in the brain to condition long-lasting changes in dysfunctional neural pathways without the systemic side effects that often occur with medications. The magnetic field is created by a special coil that focuses the magnetic energy at very specific areas of the brain, such as the pre-frontal cortex, which is the primary cortical area involved in emotional regulation. The course of treatment involves multiple sessions over time, which is also known as repetitive TMS (rTMS). Most standard treatment plans involve 30 sessions, at a rate of 1 per day, 5 days a week, over 6 weeks. These treatments are completed by our advanced treatment team, Revolution Treatments.
                        </p>
                    </div>
                    <div className="col-md-6">
                        <LazyLoadImage
                            src="/img/dr-friday-tms.jpg"
                            alt="ADHD Testing"
                            className="img-fluid"
                            style={{ borderRadius: "30px" }}
                        />
                    </div>
                </div>
                {/* Services Grid */}
                <div
                    className="w-100"
                    style={{
                        background: 'linear-gradient(90deg, #CDD7E9 0%, rgba(45, 80, 145, 0.92) 22%, rgba(45, 79, 144, 0.93) 79%, #CDD7E9 100%)'
                    }}
                >
                    <div className="container">
                        <h2 className="text-center text-white mb-0">Services</h2>
                    </div>
                </div>
                <div
                    className="w-100"
                    style={{
                        background: 'rgba(138.25, 212.19, 255, 0.20)'
                    }}
                >
                    <div className="container py-5">
                        <div className="row text-center gy-5">
                            {/* IV Ketamine */}
                            <div className="col-12 col-md-4">
                                <h3
                                    className="mt-3"
                                    style={{
                                        color: '#2D4F90',
                                        fontSize: 36,
                                        fontFamily: 'Poppins',
                                        fontWeight: 600,
                                        lineHeight: '46px'
                                    }}
                                >
                                    Depression and OCD
                                </h3>
                                <p
                                    className="text-secondary"
                                    style={{
                                        fontSize: 18,
                                        fontFamily: 'Poppins',
                                        lineHeight: '28px'
                                    }}
                                >
                                    For patients who have tried therapy, medication, and other alternatives but still not found relief, TMS offers new hope. TMS can condition long-term changes in specific, targeted areas of the brain. In depression, a specific area of the frontal lobe of the brain, known as the dorsolateral pre-frontal cortex, is underactive. TMS stimulation causes the neurons in the brain to fire in a specific pulse pattern that can strengthen and heal the prefrontal cortex over time.
                                </p>
                            </div>

                            {/* IM Ketamine */}
                            <div className="col-12 col-md-4">
                                <h3
                                    className="mt-3"
                                    style={{
                                        color: '#2D4F90',
                                        fontSize: 36,
                                        fontFamily: 'Poppins',
                                        fontWeight: 600,
                                        lineHeight: '46px'
                                    }}
                                >
                                    Autism
                                </h3>
                                <p
                                    className="text-secondary"
                                    style={{
                                        fontSize: 18,
                                        fontFamily: 'Poppins',
                                        lineHeight: '28px'
                                    }}
                                >
                                    As a growing expanse of research shows appropriate TMS protocols can greatly improve quality of life for those with autism, demand has grown for this use case. While insurance may still take years to cover TMS used for autism, our doctors have developed a protocol that is research supported, patient approved, and cost affordable. For more information on how TMS can improve quality of life for those with autism, <a href="https://revolutiontreatments.com/tms-autism-protocol" target="_blank" rel="noopener noreferrer">visit the Autism TMS resources at Revolution Treatments</a>, our advanced treatment team.
                                </p>
                            </div>

                            {/* Nasal Spray / Spravato® */}
                            <div className="col-12 col-md-4">
                                <h3
                                    className="mt-3"
                                    style={{
                                        color: '#2D4F90',
                                        fontSize: 36,
                                        fontFamily: 'Poppins',
                                        fontWeight: 600,
                                        lineHeight: '46px'
                                    }}
                                >
                                    Anxiety, TMJ, Tinnitus, ADHD
                                </h3>
                                <p
                                    className="text-secondary"
                                    style={{
                                        fontSize: 18,
                                        fontFamily: 'Poppins',
                                        lineHeight: '28px'
                                    }}
                                >
                                    TMS can also be used to treat anxiety, TMJ, Tinnitus, ADHD, and other disorders. Because research on TMS and these disorders is still limited, Redemption does not offer them outright as standalone treatments, however, depending on your specific diagnoses and medical history, some patients may qualify to do these treatments in conjunction with standard TMS depression treatment at no extra cost!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Costs & Coverage */}
                <div className="container" style={{ marginTop: '120px' }}>
                    <div className="row d-flex justify-content-between" style={{ margin: '0 -10px' }}>
                        {/* Left */}
                        <motion.div
                            className="col-12 col-md-4 d-flex justify-content-between"
                            style={{ padding: '0 15px', marginBottom: '2rem' }}
                            whileHover={{ y: -8, scale: 1.02 }}
                            transition={{ type: 'spring', stiffness: 300, damping: 25 }}
                        >
                            <div
                                style={{
                                    padding: '5px 0 30px',
                                    background: 'linear-gradient(180deg, #e8f6ff 0%, #8bd4ff 100%)',
                                    border: 'none',
                                    textAlign: 'center',
                                    lineHeight: 1.625,
                                    borderRadius: 8,
                                    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.3)'
                                }}
                            >
                                <h4 style={{
                                    margin: '15px 0',
                                    fontSize: '1.5rem',
                                    fontWeight: 600,
                                    color: '#2D4F90'
                                }} >Intake, Insurance, and Authorization</h4>
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                    <li style={{ paddingLeft: '15px', paddingRight: '15px' }}>
                                        TMS is FDA approved for treatment resistant depression and OCD, with most insurances covering TMS for depression and some covering for OCD. Patients who are not already established first meet with a psychiatric provider, who will work with them to make sure they meet qualifications before connecting them with a TMS coordinator, who will send a prior authorization to their insurance.
                                    </li>
                                </ul>
                            </div>
                        </motion.div>

                        {/* Middle */}
                        <motion.div
                            className="col-12 col-md-4 d-flex justify-content-between"
                            style={{ padding: '0 15px', marginBottom: '2rem' }}
                            whileHover={{ y: -8, scale: 1.02 }}
                            transition={{ type: 'spring', stiffness: 300, damping: 25 }}
                        >
                            <div
                                style={{
                                    padding: '5px 0 30px',
                                    background: 'linear-gradient(180deg, #1B2F54 0%, #3B67BA 100%)',
                                    border: 'none',
                                    textAlign: 'center',
                                    lineHeight: 1.625,
                                    borderRadius: 8,
                                    transform: 'scale(1.1)',
                                    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.3)'
                                }}
                            >
                                <h4
                                    style={{
                                        margin: '5px 0',
                                        fontSize: '1.5rem',
                                        fontWeight: 600,
                                        color: '#FFF',
                                        marginBottom: '15px'
                                    }}
                                >
                                    Self Pay Rates
                                </h4>
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                    <li
                                        style={{
                                            fontSize: '2.5rem',
                                            lineHeight: 1,            // make the line-height equal to font-size
                                            background: '#3B67BA',
                                            color: '#FFF',
                                            padding: '20px',
                                        }}
                                    >
                                        $2,500
                                        <span style={{ fontSize: '1rem', lineHeight: 1.2 }}>
                                            <br />
                                            (or less!) for self pay patients!
                                        </span>
                                    </li>
                                    <li style={{ paddingLeft: '15px', paddingRight: '15px', color: '#FFF' }}>
                                        For patients without insurance, most clinics in the greater Phoenix area charge between $5,000 and $12,500 for a full series of TMS. Redemption Psychiatry charges $2,500, ensuring that patients have access to this life changing treatment. Learn more about how we keep treatments affordable at our partner website <a href="https://revolutiontreatments.com/tms-coverage-and-costs" target="_blank" rel="noopener noreferrer" style={{ color: '#8bd4ff', textDecoration: 'underline' }}>Revolution Treatments</a>.
                                    </li>
                                </ul>
                            </div>
                        </motion.div>

                        {/* Right */}
                        <motion.div
                            className="col-12 col-md-4 d-flex justify-content-between"
                            style={{ padding: '0 15px', marginBottom: '2rem', }}
                            whileHover={{ y: -8, scale: 1.02 }}
                            transition={{ type: 'spring', stiffness: 300, damping: 25 }}
                        >
                            <div
                                style={{
                                    padding: '5px 0 30px',
                                    background: 'linear-gradient(180deg, #e8f6ff 0%, #8bd4ff 100%)',
                                    border: 'none',
                                    textAlign: 'center',
                                    lineHeight: 1.625,
                                    borderRadius: 8,
                                    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.3)'
                                }}
                            >
                                <h4 style={{
                                    margin: '15px 0',
                                    fontSize: '1.5rem',
                                    fontWeight: 600,
                                    color: '#2D4F90'
                                }} > Discounts, Ketamine, <br /> & more </h4>
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                    <li style={{ paddingLeft: '15px', paddingRight: '15px' }}>
                                        Because ketamine and TMS work in tandem to radically improve mood disorders and brain health, Redemption offers patients who qualify for both and complete a series of TMS 2 probono ketamine IV sessions, allowing more people to experience both at the same time , creating the best possible opportunity for full remission of symptoms. Additionally, some patients may qualify for discounts depending on life circumstance. For more information, ask to speak to one of our TMS Coordinators!
                                    </li>
                                </ul>
                            </div>
                        </motion.div>
                    </div>
                </div>

                {/* Partner Callout */}
                <div
                    className="w-100"
                    style={{ background: '#e8f6ff', marginTop: '80px' }}
                >
                    <div className="container pt-5">
                        <div className="row align-items-center">
                            {/* Left: text + buttons */}
                            <div className="col-12 col-md-8">
                                <h2> Learn More About TMS at Our Partner Website: </h2>
                                <p> Revolution Treatments is the name of our advanced treatment team, working hard to use modern research to develop the best ketamine, TMS, DBS, and VNS treatments for your benefit. To learn more about all things TMS, or to explore other revolutionary treatments, click below! Or, if you would like to discuss these treatments with a psychiatric provider, schedule an intake today! </p>
                                <a
                                    href="https://revolutiontreatments.com"
                                    className="button blue"
                                    style={{ marginBottom: '30px', marginRight: '30px' }}
                                >
                                    Revolution Treatments
                                </a>
                                <a href="https://rpsych.com/newpatients" className="button blue" style={{ marginBottom: '30px' }}>
                                    Schedule an Intake
                                </a>
                            </div>

                            {/* Right: partner logo */}
                            <div className="col-12 col-md-4">
                                <LazyLoadImage
                                    src="/img/revolution-logo.svg"
                                    alt="Revolution Treatments Logo"
                                    effect="blur"
                                    className="img-fluid"
                                    style={{
                                        width: '200%',    // twice as wide as the container-based "100%"
                                        maxWidth: 'none', // allow overflow of the parent's 100% cap
                                        height: 'auto'    // preserve aspect ratio
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/* Widgets Section (reused) */}
                <Widgets />
            </div>
        </div>
        <Footer />
    </>
);

export default NeurologicalTesting;
